<template>
  <v-dialog v-model="open" max-width="500px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <location-info-item
          icon="mdi-text"
          icon-action="mdi-pencil-outline"
          title="Descrição"
          :subtitle="location.data ? location.data.description : formData.description"
          v-bind="attrs"
          v-on="on"
      />
    </template>

    <v-card>
      <v-toolbar elevation="0">
        <v-card-title class="ml-0 pl-1">
          Da empresa
        </v-card-title>

        <v-spacer />

        <v-btn icon @click="open = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>Escreva uma breve descrição da sua empresa.</v-card-text>

      <v-card-text>
        <v-form
            @submit="e => e.preventDefault()"
            ref="form"
            v-model="formValid"
            lazy-validation
        >
          <v-textarea
              v-model="formData.description"
              :rules="descriptionRules"
              required
              outlined
              v-on:keyup.enter="() => callAction()"
          ></v-textarea>

          <v-alert
            v-if="alertScheduledTask"
            dense
            border="right"
            type="warning"
          >
            Existe um agendamento pendente para essa informação
          </v-alert>

          <schedule-form  v-if="!bulkUpdate" small v-on:change="changeScheduleDate" />
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="secondary"
            text
            @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
            :loading="loading"
            color="primary"
            text
            @click="callAction"
        >
          Aplicar
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import LocationInfoItem from '@/views/Locations/Components/LocationInfoItem'
import {mapState} from 'vuex'
import { get } from 'lodash'
import {TYPE_UPDATE_LOCATION_DESCRIPTION} from '@/constants/tasks'
import ScheduleForm from '@/views/Locations/Components/ScheduleForm'

export default {
  name: "LocationDescriptionModal",
  computed: {
    ...mapState({
      location: state => state.locations.location
    })
  },
  props: {
    action: Function,
    bulkUpdate: {
      type: Boolean,
    },
    alertScheduleTask: Array,
  },
  components: {
    LocationInfoItem,
    ScheduleForm
  },
  methods: {
    cancel: function() {
      this.open = false
      this.resetData()
    },
    resetData: function() {
      const {description} = this.formDataOriginal
      this.formData.description = description
      if (this.bulkUpdate) {
        this.$emit('removePayload', 'description')
      }
    },
    callAction: async function () {
      this.validate()
      if (!this.formValid) {
        return false
      }

      if(this.bulkUpdate){
        this.$emit('savePayload', "description", this.formData.description)
      } else if (this.action) {
        this.loading = true
        await this.action(this.formData)
        this.loading = false
      }

      this.open = false
    },
    validate: function() {
      return this.$refs.form.validate()
    },
    changeScheduleDate: function(data) {
      this.formData.schedule_start = data.schedule_start
      this.formData.schedule_start_at = data.schedule_start_at
      this.formData.schedule_end = data.schedule_end
      this.formData.schedule_end_at = data.schedule_end_at
    }
  },
  beforeDestroy() {
    this.resetData()
  },
  mounted() {
    if(this.alertScheduleTask) {
      this.alertScheduleTask.map(type => {
        if(type === TYPE_UPDATE_LOCATION_DESCRIPTION) {
          this.alertScheduledTask = true;
        }
      })
    }
  },
  data: () => ({
    open: false,
    loading: false,
    formValid: true,
    formData: {
      schedule_type: TYPE_UPDATE_LOCATION_DESCRIPTION,
      description: '',
      schedule_start: '',
      schedule_start_at: '',
      schedule_end: '',
      schedule_end_at: ''
    },
    formDataOriginal: {},
    descriptionRules: [
      v => !!v || 'A descrição é obrigatório'
    ],
    alertScheduledTask: null,
  }),
  watch: {
    location(location) {
      if (!this.bulkUpdate) {
        this.formData.description = get(location, 'data.description')
        this.formDataOriginal.description = get(location, 'data.description')
      }
    },
    open(open) {
      if (open && !this.bulkUpdate) {
        this.formData.description = get(this.location, 'data.description')
        this.formDataOriginal.description = get(this.location, 'data.description')
      }
    }
  }
}
</script>

<style scoped>

</style>